import React, { useEffect } from 'react'
import Board from '../components/Board';
import FileUploader from '../components/FileUploader';
// import '../styles/upload.css'
import ReactGA from "react-ga"
import '../styles/Primal.css'

const Primal = () => {
  return (
    <div className="primalpage-div">
      <br /><br /><br />
      <div className="primal-container">

        <div className="primal-board">
        <br />
          <FileUploader />
          <Board />
        </div>

        <div className="primal-content">
          <div className="primal-text">
            <h1>About Our Interactive Demo</h1>
            <p>This online interactive demo allows you to create arbitrary multi-agent pathfinding
              (MAPF) instance on square grid worlds, by placing obstacles, agents (robots),
              and corresponding goals, before running a trained PRIMAL model in real-time to
              see agents plan individual collision-free paths to their goal. The full PRIMAL paper
              is available at <a href="https://arxiv.org/abs/1809.03531">this link</a>, while the full
              training and testing code is available on <a href="https://github.com/gsartoretti/PRIMAL">github</a>.
              More information and resources about MAPF can be found at <a href="http://mapf.info/">the main MAPF community website</a>.
              <br /><br />
              <b>Important disclaimer:</b> PRIMAL does not provide any completeness/optimality guarantees,
              so you may very well find cases that the trained model cannot complete.
              The <a href="https://marmotlab.org/">MARMot Laboratory</a> at NUS is still actively building
              upon/extending it, see <a href="https://arxiv.org/abs/2010.08184">
              this paper</a> and <a href="https://arxiv.org/abs/2303.00605">this other one</a> for recent progress along this line of work.
              We will also be continuing to improve this interface and add functionalities (e.g., non-square grids,
              other models such as PRIMAL2/SCRIMP, etc.).</p>
              <br />
              <p>Start by reading the instructions by clicking on the “How to play” 
              button, and have fun (stress-)testing PRIMAL!</p>
          </div>
        </div>

      </div>

    </div>

  )
}

export default Primal
